import { useNavigate } from "react-router-dom";
import Button from '@mui/material/Button';

type Props = {
  redirect: string,
  text: string
}

export default function AcceptButton(props: Props) {

  let navigate = useNavigate();
  const routeChange = () =>{
    navigate(props.redirect, { replace: true });
  }

  return (
    <Button className="primary login" size="small" type="submit" onClick={routeChange}>{props.text}</Button>
  );
}